import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from './ui/button';

export default function LegalPage({ title, lastUpdated, children }) {
  const navigate = useNavigate();
  return (
    <div className="legal-page">
      <header className="legal-nav">
        <div className="legal-nav-inner">
          <button
            className="legal-nav-brand"
            onClick={() => navigate('/')}
            data-testid="legal-nav-home"
            aria-label="Rental P.A. — back to home"
          >
            <img src="/logo-transparent.png" alt="Rental P.A." className="landing-nav-brand-img" />
          </button>
          <div className="legal-nav-actions">
            <button
              className="landing-nav-link"
              onClick={() => navigate('/login')}
              data-testid="legal-nav-login"
            >
              Log In
            </button>
            <Button
              className="btn-primary landing-nav-cta"
              onClick={() => navigate('/signup')}
              data-testid="legal-nav-signup"
            >
              Sign Up
            </Button>
          </div>
        </div>
      </header>

      <main className="legal-content">
        <h1 data-testid="legal-title">{title}</h1>
        <p className="legal-last-updated">Last updated: {lastUpdated}</p>
        {children}
        <div className="legal-footer-cta">
          <button onClick={() => navigate('/')} className="legal-back-link" data-testid="legal-back-home">
            ← Back to Rental P.A.
          </button>
        </div>
      </main>

      <footer className="landing-footer">
        <div className="landing-container">
          <img src="/logo.png" alt="Rental P.A." className="landing-footer-logo" />
          <p className="landing-footer-copy">&copy; 2026 Rental P.A. Built for UK landlords.</p>
          <p className="landing-footer-links">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="footer-sep">|</span>
            <Link to="/terms">Terms of Service</Link>
          </p>
        </div>
      </footer>
    </div>
  );
}
